<template lang="pug">
section.visible__layout
  h1.h1-title {{ $t('common.promos') }}

  spacer(size="40px")

  .tab-controls
    button.tab-controls__item(@click="changeType(0)",
          :class="{ 'active': active == 0 }")
      span.tab-controls__item__title {{ $t('actual') }}
      span.tab-controls__item__anchor
    button.tab-controls__item(@click="changeType(1)",
          :class="{ 'active': active == 1 }")
      span.tab-controls__item__title {{ $t('common.used') }}
      span.tab-controls__item__anchor

  spacer(size="50px")

  div
    //- .row
      .row-objects_cat
        a.button.button_secondary-round.uppercase.semi-bold(@click="changeType(0)",
          :class="{ 'active': active == 0 }") Актуальные
        a.button.button_secondary-round.uppercase.semi-bold(@click="changeType(1)",
          :class="{ 'active': active == 1 }") Архив
    .tabs
      .tab
        //- .tab__title(v-if="active == 0") Актуальные
        //- .tab__title(v-if="active == 1") Архив
        .tab__content
          skeleton(v-if="loading", :type="'orders'", :count="1")
          template(v-if="!loading && promotions && promotions.length")
            .orders
              promotion(v-for="promotion in promotions", :promotion="promotion")
            .pag(v-if="lastPage && lastPage > 1")
              pagination(:current="page", :pages="lastPage", @load="toPage")
          .no-orders(v-if="promotions && promotions.length == 0")
            .no-orders__message
              i.grey-ticket
              .label(v-if="active == 0") {{ $t('promotions.noCouponsActual') }}
              .label(v-if="active == 1") {{ $t('promotions.noCouponsUsed') }}
            button.button.button_primary(v-if="!hideRedirect" @click="toPromos()") {{ $t('promotions.goToSite') }}
</template>

<script>
import API from '@/api/api';
import Promotion from '@/components/Promotion';
import Pagination from '@/components/Pagination';
import Skeleton from '@/components/Skeleton';

export default {
  components: {
    Promotion,
    Pagination,
    Skeleton,
  },
  data() {
    return {
      active: 0,
      promotions: null,
      page: 1,
      lastPage: null,
      loading: true,
      hideRedirect: false,
    };
  },
  mounted() {
    this.getPromotions();
    if (window.location.host.includes('guru.ge')) this.hideRedirect = true;
  },
  methods: {
    async getPromotions() {
      this.loading = true;
      const data = await API.getPromotions({
        archive: this.active,
        page: this.page,
        perPage: 4,
      });
      if (data && data.data) {
        this.promotions = data.data;
        this.lastPage = data.last_page;
        this.loading = false;
      }
    },
    changeType(type) {
      this.page = 1;
      this.active = type;
      this.getPromotions();
    },
    toPage(page) {
      this.page = page;
      this.getPromotions();
    },
    toPromos() {
      // let isProd = true;
      // if (process.browser && window) {
      //   isProd = window.location.href.match(/^https:\//);
      // }
      // if (isProd) {
      //   window.open('https://24skidki.by');
      // }
      window.open('https://24skidki.by');
      // window.open('http://skidki.24.arcom.of.by');
    },
  },
};
</script>

<style lang="scss">
.no-orders__message{
  .label{
    margin-bottom: 20px;
  }
}
</style>
